import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import CampaignIcon from '@mui/icons-material/Campaign';

import useStyles from './style';

interface INoResultsProps {
  title?: string;
  description?: string;
}

const NoResults = ({ title, description }: INoResultsProps) => {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const hasCustomTexts = !!title || !!description;

  return (
    <Box className={classes.root}>
      <NoResultsIcon />
      {hasCustomTexts ? (
        <>
          {!!title && (
            <Typography variant="h2" className={classes.title}>
              {title}
            </Typography>
          )}
          {!!description && (
            <Typography variant="text-md" className={classes.description}>
              {description}
            </Typography>
          )}
        </>
      ) : (
        <Typography className={classes.text}>
          {t('common.noDataToDisplayMessage')}
        </Typography>
      )}
    </Box>
  );
};

export default NoResults;

const NoResultsIcon = () => {
  const theme = useTheme();

  return (
    <svg viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="20"
        y="15"
        width="80"
        height="60"
        rx="8"
        strokeWidth="2"
        fill={theme.palette.disabled}
        stroke={theme.palette.font.secondary}></rect>
      <circle
        cx="60"
        cy="45"
        r="15"
        stroke={theme.palette.font.secondary}
        strokeWidth="2"
        strokeDasharray="4 4"
        fill="none"></circle>
      <path
        d="M55 60C55 57.2386 57.2386 55 60 55C62.7614 55 65 57.2386 65 60C65 61.6569 64.1046 63.1046 62.7614 64C61.5 64.8 60 66 60 68"
        transform="translate(0 -20)"
        stroke={theme.palette.font.secondary}
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"></path>
      <circle
        cx="60"
        cy="53"
        r="1.5"
        fill={theme.palette.font.secondary}></circle>
      <circle
        cx="90"
        cy="22"
        r="4"
        fill={theme.palette.primarySamitransparent}></circle>
      <circle
        cx="25"
        cy="25"
        r="3"
        fill={theme.palette.primarySamitransparent}></circle>
      <rect
        x="83"
        y="62"
        width="8"
        height="8"
        rx="2"
        fill={theme.palette.primarySamitransparent}
        transform="rotate(15 89 89)"></rect>
    </svg>
  );
};
